import loadable from '../../utilities/loadable'

export const SendReminder = loadable(() => import('./SendReminder'))
export const EditLocationAllocationModal = loadable(() => import('./EditLocationAllocationModal'))
export const ViewLocationAllocationModal = loadable(() => import('./ViewLocationAllocationModal'))
export const AcceptCounterOfferLocationModal = loadable(() => import('./AcceptCounterOfferLocationModal'))
export const ProductOffersHistoryModal = loadable(() => import('./ProductOffersHistoryModal'))
